// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__3FfcR"};